import Vue from 'vue';
import $ from "webpack-zepto";

import SearchApp from './SearchApp.vue';
import Autocomplete from './components/Autocomplete';

import store from './store/store';

new Vue({
    el: $("[data-behavior='vue-search-app']")[0],
    store,
    render: function (h) { return h(SearchApp) }    
});

new Vue({
    el: $("[data-behavior='vue-search-app__autocomplete']")[0],
    store,
    render: function (h) { return h(Autocomplete) }
});

$("html").addClass("vue-loaded");
$("[data-behavior='vue-search-app__noscript-autocomplete']").remove();